// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'
import '../src/styles/theme/index.css'
import '../src/styles/icomoon.css'
import '../src/styles/common.css'
import App from './App'
import store from './store'
import router from './router'
import commonjs from '../src/script/common.js'
import validation from '../src/script/validation.js'
import AppPagination from '../src/components/common/AppPagination.vue'
import ColumnsControl from '../src/components/common/ColumnsControl.vue'
import Router from 'vue-router'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.snow.css'
import * as Quill from 'quill'
import { decode } from 'js-base64';
import msal from 'vue-msal'

var forge = require('node-forge');
var fonts = ['outage','outagecut','gothamblack','gothambold','gothambook','gothamlight','gothammedium','gothamultra','gothamultra2','oswaldbold','oswaldbolditalic','oswalddemibold','oswalddemibolditalic','oswaldextralight','oswaldextralightitalic','oswaldheavy','oswaldheavyitalic','oswaldlight','oswaldlightitalic','oswaldmedium','oswaldmediumitalic','oswaldregular','oswaldregularitalic','oswaldstencil'];
var Font = Quill.import('formats/font');
Font.whitelist.unshift('sans-serif');
var newFonts = Font.whitelist.concat(fonts);
Font.whitelist = newFonts;
Quill.register(Font, true);

Vue.use(ElementUI, { locale })
Vue.component('app-pagination', AppPagination)
Vue.component('columns-control', ColumnsControl)
Vue.config.productionTip = false
Vue.prototype.$commonjs = commonjs
Vue.prototype.$validation = validation
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
Vue.prototype.baseURL = window.location.protocol + process.env.API_ROOT;
Vue.prototype.bearer = 'Bearer ';
Vue.use(VueQuillEditor,{
    modules:{
      toolbar:[
            ['bold', 'italic', 'underline', 'strike'],
            // ['blockquote', 'code-block'],
            // [{ 'header': 1 }, { 'header': 2 }],  
            // [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            // [{ 'script': 'sub'}, { 'script': 'super' }],
            // [{ 'indent': '-1'}, { 'indent': '+1' }], 
            // [{ 'direction': 'rtl' }],       
            // [{ 'size': ['small', false, 'large', 'huge'] }],
            // [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            // [{ 'color': [] }, { 'background': [] }],
            // [{ 'font': newFonts }], 
            // [{ 'align': [] }],
            ['link'],
            // ['clean'],
            // ['image','video']
        ]
    },
    theme:'snow'
})
Vue.use(msal, {
    auth: {
      clientId: 'b32f3c01-3eda-42bf-9df7-c56c2270f96f',
      authority: 'https://login.microsoftonline.com/999e99bd-b19e-4a70-911c-060bf4fde2f9',
      redirectUri: 'http://localhost:8088',
      responseType: 'token'
    }
});

// Vue.prototype.$getRsaCode = function(str){ // 注册方法
//     let pubKey = window.sessionStorage.getItem('pubKey');
//     if (!pubKey) {
//         return;
//     }
    
//     let encryptStr = new JSEncrypt();
//     encryptStr.setPublicKey(pubKey); // 设置 加密公钥
//     let data = encryptStr.encrypt(str.toString());  // 进行加密
//     return data;
// }

Vue.prototype.$encryptedRSAOAEP = function(str,flag=false){
    // let pubKey = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAz6v9U622G0exFV62ipTIIDdK7ReQy5fgeFV9rgFQOuYQtcGXmA8q585f6JFnERaKl7Jk+CeIKBTzmp1teicfd6M5Gcm7mwWVpF6RJoV/CDGp+1JcZD20deoqwDmzyc9GUPxHIsB901Cy009maoKgicAd/UFSdDu242UcMapgvQJFsojPMhPHeeoqsWPL1BFdzO/1T20/mpaumtq8i+sHo/0fWdc5BLeUZJlnVX/lzc5y26q9MS/gWFEZmMJxpOwxRJ3hd4NLNlpjFAN+MDj78TNrDT5iy/m/3NkovFLzYZNAG84xzAht4QdYaaldmP2r76EE+eBjvZ9/UGF/r7FVawIDAQAB';

    let pubKey = window.sessionStorage.getItem('pubKey');
    pubKey = "-----BEGIN PUBLIC KEY-----\n" + pubKey + "\n-----END PUBLIC KEY-----";
    var publicKey = forge.pki.publicKeyFromPem(pubKey);
    var encrypted = publicKey.encrypt(str, 'RSA-OAEP', {
        md: forge.md.sha256.create(),
        mgf1: {
            md: forge.md.sha1.create()
        }
    });
    if(flag){
        return encrypted;
    }else{
        return forge.util.encode64(encrypted);
    }
}
//哈希url
Vue.prototype.$hash256 = function(url){
    let md = forge.md.sha256.create();
    md.update(url);
    return md.digest().toHex()
}
//反base64
Vue.prototype.$decodeBase64 = function (str){
    return decode(str);
}
//截取参数分段返回数组
Vue.prototype.$sliceStr = function(str){
    var strArr = [];
    var maxLength = 62;
    for (var i = 0, l = str.length; i < l/maxLength; i++) {
        var a = str.slice(maxLength*i, maxLength*(i+1));
        strArr.push(a);
    }
    return strArr;
}
//base64 转url编码
Vue.prototype.transformBase64 = function(ba64){
    return ba64.replace(/\+/g, "%2B")
            .replace(/\//g, "%2F")
            .replace(/=/g, "%3D")
}

Vue.prototype.$encUrl = function(url){
    let token = sessionStorage.getItem('token').split('.')[1];
    let aud = JSON.parse(this.$decodeBase64(token)).aud;
    let hashUrl = this.$hash256(url);
    let params = `aud=${aud}&hash=${hashUrl}`;
    let encParams = '';
    if(params.length>62){
        let sliceArr = this.$sliceStr(params);
        let fullEnc = '';
        sliceArr.forEach(item=>{
            fullEnc = fullEnc +this.$encryptedRSAOAEP(item,true)
        })
        encParams = forge.util.encode64(fullEnc);
        
    }else{
        encParams = this.$encryptedRSAOAEP(params);
    }
    // console.log(this.transformBase64(encParams))
    return this.transformBase64(encParams);
}

Vue.prototype.$message = function (msg) {
    ElementUI.Message(msg)
}
Vue.prototype.$message.success = function (msg) {
    return ElementUI.Message.success({
        message: msg,
        duration: 5000,
        customClass:'walton-success',
        showClose:true
    })
}
// Vue.prototype.$message.warning = function (msg) {
//     return ElementUI.Message.warning({
//         message: msg,
//         duration: 1000
//     })
// }
Vue.prototype.$message.error = function (msg) {
    return ElementUI.Message.error({
        message: msg,
        duration: 5000,
        customClass:'walton-error',
        showClose:true
    })
}

/* eslint-disable no-new */
new Vue({
    el: '#app',
    store,
    router,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js